export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceName: "アイラ地域サポート",
      serviceContentsSettings: [
        {
          serviceContentsId: 2,
          serviceContentsUuid: "servicecontents002",
          contentsName: "地域サポート",
          serviceType: "hoam",
          deviceTypeUuid: "device001",
          deviceType: "JS01K"
        },
        {
          serviceContentsId: 1,
          serviceContentsUuid: "servicecontents001",
          contentsName: "アコミュニティサポート",
          serviceType: "hoambox",
          deviceTypeUuid: "device002",
          deviceType: "JS01H"
        }
      ]
    }
  }
}